import {SharedQuestion} from "./SharedQuestion";

export class CheckboxSharedQuestion extends SharedQuestion {

    protected values:IValue[] = [];

    isValid():boolean {
        super.isValid();

        if (!this.question.required) {
            return true;
        }

        for (const value of this.values) {
            if (value.value) {
                return true;
            }
        }

        return false;
    }

    validationMessage():string {
        var message = this.getMessage('required');
        if (message) {
            return message;
        }

        return 'checkbox_validation_message';
    }

    getValue():IValue[] {
        return this.values;
    }

    setValue(value:IValue) {
        for (let oldValue of this.values) {
            if (oldValue.choice === value.choice) {
                oldValue.value = value.value;
                return;
            }
        }

        this.values.push(value);
    }

    satisfiesValue(currentValues:IValue[], value:IValue):boolean {
        for (let currentValue of currentValues) {
            if (currentValue.row === value.row && currentValue.choice === value.choice) {
                return value.value;
            }
        }

        // value doesn't exists which means that it is false
        // if node wants it to be false then it satisfies logic
        return !value.value;
    }

    isAnswerEmpty(answer: IAnswer): boolean {
        let isEmpty = true;
        for (let value of answer.values) {
            if (value.value) {
                isEmpty = false;
                break;
            }
        }

        return isEmpty;
    }
}